import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { createGebuehrenVorgangSaga } from "./sagas/createGebuehrenVorgangSaga";

const gebuehrenforderungModule = (): Module => ({
	id: "gebuehrenforderung",
	sagas: () => [createGebuehrenVorgangSaga]
});
export default gebuehrenforderungModule;
